import type { ReactNode } from 'react'
import { Link } from 'react-router'
import { Button, Tooltip } from '@mantine/core'
import { IconArrowRight } from '@tabler/icons-react'

// The small right-aligned action button used on list rows (dashboard "What's
// next" / "Pick up where you left off", threads). A light, compact link button
// with a trailing arrow, wrapped in a tooltip so the label reads even when the
// row is dense. Sits inside a card's z-indexed actions group when the whole
// card is also a (stretched) link — see the .actions / .titleLink CSS pattern.
export interface RowActionButtonProps {
    to: string
    label: string
    icon?: ReactNode
}

export function RowActionButton({ to, label, icon }: RowActionButtonProps) {
    return (
        <Tooltip label={label}>
            <Button
                size='compact-sm'
                variant='light'
                component={Link}
                to={to}
                rightSection={icon ?? <IconArrowRight size={14} />}
            >
                {label}
            </Button>
        </Tooltip>
    )
}
